import { type WidgetSettingsDefinition } from "@repo/api";

import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const WORK_ORDERS_SETTINGS: WidgetSettingsDefinition[] = [
  COMMON_SETTINGS.COWORKER,
  COMMON_SETTINGS.STORE,
  {
    id: "workType",
    title: "label.work_type",
    type: "selection",
    stringValues: [
      "Install (Consecutive Days)",
      "IKEA Measure (US)",
      "IKEA Measure & Plan (US)",
      "Pre Installation Visit (US)",
      "Go Back",
      "Warranty",
      "Show Room Work",
    ],
    additionalControl: { selectionMode: "MULTI", showSearch: false },
  },
  {
    id: "status",
    title: "label.status",
    type: "selection",
    stringValues: ["New", "In Progress", "Go Back Needed", "Final Status"],
    additionalControl: { selectionMode: "MULTI", showSearch: false },
  },
  {
    id: "scheduledStartTimeFilter",
    title: "label.scheduled_start_time",
    type: "date_range",
  },
  {
    id: "measurementFilesUploaded",
    title: "label.measurement_files_uploaded",
    type: "boolean",
  },
];
